// extracted by mini-css-extract-plugin
module.exports = {"insightCard":"InsightCard_insightCard__vl99u","cardValue":"InsightCard_cardValue__zqXao","cardTitle":"InsightCard_cardTitle__Ywkre"};